export var ProgramStatus;
(function (ProgramStatus) {
    ProgramStatus["Canceled"] = "Canceled";
    ProgramStatus["Rejected"] = "Rejected";
    ProgramStatus["Active"] = "Active";
    ProgramStatus["Completed"] = "Completed";
})(ProgramStatus || (ProgramStatus = {}));
export const ProgramInitialState = {
    program_id: '',
};
export var ProgramGrantStatus;
(function (ProgramGrantStatus) {
    ProgramGrantStatus["Identified"] = "identified";
    ProgramGrantStatus["Qualify"] = "qualify";
    ProgramGrantStatus["Handoff"] = "handoff";
    ProgramGrantStatus["KickoffWriting"] = "kickoff_writing";
    ProgramGrantStatus["Review"] = "review";
    ProgramGrantStatus["Submitted"] = "submitted";
    ProgramGrantStatus["Accepted"] = "accepted";
    ProgramGrantStatus["Refused"] = "refused";
    ProgramGrantStatus["ClosedLost"] = "closed_lost";
})(ProgramGrantStatus || (ProgramGrantStatus = {}));
export const AdminVisibleProgramGrantStatuses = [
    ProgramGrantStatus.Identified,
    ProgramGrantStatus.Qualify,
    ProgramGrantStatus.Handoff,
    ProgramGrantStatus.KickoffWriting,
    ProgramGrantStatus.Review,
    ProgramGrantStatus.Submitted,
    ProgramGrantStatus.Accepted,
    ProgramGrantStatus.Refused,
    ProgramGrantStatus.ClosedLost,
];
export const ProgramGrantStatusDisplayMap = {
    identified: ProgramGrantStatus.Identified,
    qualify: ProgramGrantStatus.Qualify,
    handoff: ProgramGrantStatus.Handoff,
    kickoff_writing: ProgramGrantStatus.KickoffWriting,
    review: ProgramGrantStatus.Review,
    submitted: ProgramGrantStatus.Submitted,
    accepted: ProgramGrantStatus.Accepted,
    refused: ProgramGrantStatus.Refused,
    closed_lost: ProgramGrantStatus.ClosedLost,
};
export const getProgramGrantStatusDisplayValue = (status) => {
    var _a;
    if (!status)
        return undefined;
    return (_a = ProgramGrantStatusDisplayMap[status]) !== null && _a !== void 0 ? _a : status;
};
export const getProgramGrantStatusTranslationKey = (status) => {
    if (!status)
        return '';
    const displayStatus = getProgramGrantStatusDisplayValue(status);
    return `programs|labels.${displayStatus !== null && displayStatus !== void 0 ? displayStatus : status}`;
};
export var ProgramStartGrantStatus;
(function (ProgramStartGrantStatus) {
    ProgramStartGrantStatus["Identified"] = "identified";
    ProgramStartGrantStatus["Qualify"] = "qualify";
    ProgramStartGrantStatus["Handoff"] = "handoff";
    ProgramStartGrantStatus["KickoffWriting"] = "kickoff_writing";
    ProgramStartGrantStatus["Review"] = "review";
    ProgramStartGrantStatus["Submitted"] = "submitted";
})(ProgramStartGrantStatus || (ProgramStartGrantStatus = {}));
export var ApplicationResult;
(function (ApplicationResult) {
    ApplicationResult["Pending"] = "pending";
    ApplicationResult["Accepted"] = "accepted";
    ApplicationResult["Refused"] = "refused";
})(ApplicationResult || (ApplicationResult = {}));
export var GrantsRefusalReason;
(function (GrantsRefusalReason) {
    GrantsRefusalReason["NonEligibleApplicant"] = "non-eligible applicant";
    GrantsRefusalReason["NonEligibleProject"] = "non-eligible project";
    GrantsRefusalReason["MissingDocumentation"] = "missing documentation";
    GrantsRefusalReason["AfterDeadline"] = "after_deadline";
    GrantsRefusalReason["CompetitiveProgram"] = "competitive_program";
    GrantsRefusalReason["BudgetExhausted"] = "budget_exhausted";
    GrantsRefusalReason["NoProgramFeedback"] = "no_program_feedback";
})(GrantsRefusalReason || (GrantsRefusalReason = {}));
export const GrantsRefusalReasonTranslationKeys = {
    [GrantsRefusalReason.NonEligibleApplicant]: 'refusal_reason_non_eligible_applicant',
    [GrantsRefusalReason.NonEligibleProject]: 'refusal_reason_non_eligible_project',
    [GrantsRefusalReason.MissingDocumentation]: 'refusal_reason_missing_documentation',
    [GrantsRefusalReason.AfterDeadline]: 'refusal_reason_after_deadline',
    [GrantsRefusalReason.CompetitiveProgram]: 'refusal_reason_competitive_program',
    [GrantsRefusalReason.BudgetExhausted]: 'refusal_reason_budget_exhausted',
    [GrantsRefusalReason.NoProgramFeedback]: 'refusal_reason_no_program_feedback',
};
export var ProgramType;
(function (ProgramType) {
    ProgramType["ALaCarte"] = "a_la_carte";
    ProgramType["Subscription"] = "subscription";
})(ProgramType || (ProgramType = {}));
export const ProgramTypeLabels = {
    [ProgramType.ALaCarte]: 'À la carte',
    [ProgramType.Subscription]: 'Subscription',
};
export const getProgramTypeLabel = (programType) => {
    var _a;
    if (!programType)
        return '';
    return (_a = ProgramTypeLabels[programType]) !== null && _a !== void 0 ? _a : programType;
};
export var ProgramSource;
(function (ProgramSource) {
    ProgramSource["Admin"] = "Admin";
    ProgramSource["Client"] = "Client";
})(ProgramSource || (ProgramSource = {}));
export var ProgramClientRefusalReason;
(function (ProgramClientRefusalReason) {
    ProgramClientRefusalReason["NonEligibleCompany"] = "non_eligible_company";
    ProgramClientRefusalReason["NonEligibleProject"] = "non_eligible_project";
    ProgramClientRefusalReason["MissingDocumentation"] = "missing_documentation";
    ProgramClientRefusalReason["CompetitiveProgram"] = "competitive_program";
    ProgramClientRefusalReason["Other"] = "other";
})(ProgramClientRefusalReason || (ProgramClientRefusalReason = {}));
export var ProgramTargetUser;
(function (ProgramTargetUser) {
    ProgramTargetUser["Admin"] = "admin";
    ProgramTargetUser["Client"] = "client";
})(ProgramTargetUser || (ProgramTargetUser = {}));
export var ClientProgramStatus;
(function (ClientProgramStatus) {
    ClientProgramStatus["Favourites"] = "favourites";
    ClientProgramStatus["ProjectValidationAndEligibility"] = "project_validation_and_eligibility";
    ClientProgramStatus["GatherInformation"] = "gather_information";
    ClientProgramStatus["DraftFirstVersion"] = "draft_first_version";
    ClientProgramStatus["PreSendReview"] = "pre_send_review";
    ClientProgramStatus["SubmitApplication"] = "submit_application";
    ClientProgramStatus["DecisionsMade"] = "decisions_made";
    ClientProgramStatus["Trash"] = "trash";
})(ClientProgramStatus || (ClientProgramStatus = {}));
export const normalizeClientProgramStatus = (status) => {
    if (!status)
        return undefined;
    if (status === ClientProgramStatus.Favourites) {
        return ClientProgramStatus.ProjectValidationAndEligibility;
    }
    return status;
};
export const ClientProgramStatusRank = {
    [ClientProgramStatus.Favourites]: 0,
    [ClientProgramStatus.ProjectValidationAndEligibility]: 0,
    [ClientProgramStatus.GatherInformation]: 2,
    [ClientProgramStatus.DraftFirstVersion]: 3,
    [ClientProgramStatus.PreSendReview]: 4,
    [ClientProgramStatus.SubmitApplication]: 5,
    [ClientProgramStatus.DecisionsMade]: 6,
    [ClientProgramStatus.Trash]: -1,
};
export const AdminProgramStatusRank = {
    [ProgramGrantStatus.Identified]: 0,
    [ProgramGrantStatus.Qualify]: 1,
    [ProgramGrantStatus.Handoff]: 2,
    [ProgramGrantStatus.KickoffWriting]: 3,
    [ProgramGrantStatus.Review]: 4,
    [ProgramGrantStatus.Submitted]: 5,
    [ProgramGrantStatus.Accepted]: 6,
    [ProgramGrantStatus.Refused]: 7,
    [ProgramGrantStatus.ClosedLost]: 8,
};
